// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip .tooltip-inner {\n  max-width: 440px !important;\n}", ""]);
// Exports
module.exports = exports;
